import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyboard"><Path fillRule="evenodd" clipRule="evenodd" d="M22.5 19.5H1.5V4.5H22.5V19.5ZM5.75 13V15H7.75V13H5.75ZM9.25977 13V15H14.7402V13H9.25977ZM16.25 13V15H18.25V13H16.25ZM5.75 9V11H7.75V9H5.75ZM9.25977 9V11H11.2598V9H9.25977ZM12.7402 9V11H14.7402V9H12.7402ZM16.25 9V11H18.25V9H16.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboard;
